import React from 'react';

import { cx } from '@emotion/css';
import Image from 'next/image';

type Props = {
  styles: any;
  imageLink: string;
  imageAlt: string;
  title: string;
};
export const HeroComponent = (props: Props) => {
  const { styles, imageLink, imageAlt, title } = props;

  return (
    <section className={styles.service_hero}>
      <div className={styles.container}>
        <div className={styles.inner_section}>
          <div className={styles.hero_banner}>
            <Image
              src={imageLink}
              width={0}
              height={0}
              sizes="100vw"
              alt={imageAlt}
              className={styles.hero_banner_img}
            />
          </div>
          <div
            className={cx(styles.hero_content, styles.h2, styles.main_title)}>
            {title}
          </div>
        </div>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1440"
        height="330"
        viewBox="0 0 1440 330"
        fill="none"
        className={styles.wave}>
        <path
          d="M35.3062 7.02353C222.703 35.5011 379.545 107.712 504.816 145.343C837.574 244.209 1031.72 90.9463 1440 0C1440 732.212 1440 359.592 1440 882C960 882 721 882 3.01249e-06 882C2.89477e-06 393.018 -3.70741e-06 459.12 3.01408e-06 2.18378C11.7833 3.57537 23.5538 5.18743 35.3062 7.02353Z"
          fill="#FFFCFA"></path>
      </svg>
    </section>
  );
};
